import {
  GET_PRODUCT_DATA,
  SEARCH_DATA,
  ADD_ITEM,
  EDIT_ITEM,
  OPEN_EDIT,
  OPEN_PREVIEW,
  RESET_DATA,
  LOG_ACTION,
  LOAD_MORE_PRODUCT_DATA,
  CHANGE_PRODUCT_INCOMING,
} from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";
import S3 from "react-aws-s3";

export const getProductData = (props) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products");
    console.log(props);
    if (props.searchText) {
      productdataRef = productdataRef.where("name", ">=", props.searchText);
    } else {
      productdataRef = productdataRef.orderBy("created_at", "desc");
    }

    if (props.menuItemsOnly) {
      productdataRef = productdataRef.where("menu_item", "==", true);
    } else {
      productdataRef = productdataRef.where("menu_item", "==", false);
    }

    if (userRole == "oic" && userLocation !== "kFM8i7KDX41ex78WPLyO") {
      productdataRef = productdataRef.where("hq_only", "==", false);
    }

    productdataRef = productdataRef.limit(2500);

    productdataRef
      .get()
      .then((documentSnapshots) => {
        var docs = documentSnapshots.docs;
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        docs.map((item) => {
          var newProduct = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };

          if (
            userRole == "admin" ||
            userRole == "manager" ||
            userRole == "warehouse"
          ) {
            dataArray.push(newProduct);
          } else if (newProduct.hq_only || newProduct.menu_item) {
            if (
              userLocation == "EbJPvhCb11UaKbutec49" &&
              userRole == "oic" &&
              newProduct.hq_only == false
            ) {
              dataArray.push(newProduct);
            } else if (userRole == "oic") {
              if (newProduct.hq_only == false && !newProduct.menu_item) {
                dataArray.push(newProduct);
              }
            }
            // if (userRole == "warehouse") {
            //   if (newProduct.menu_item == false) {
            //     dataArray.push(newProduct);
            //   }
            // }
          } else {
            dataArray.push(newProduct);
          }
        });

        dispatch({
          type: GET_PRODUCT_DATA,
          payload: {
            dataArray: dataArray,
            lastVisible: lastVisible,
            currentProps: props,
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const loadMoreProductData = () => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var userLocation = reduxState.auth.user.branch;
    var useremail = reduxState.auth.user.email;
    var currentLastItem = reduxState.products.lastVisible;
    var currentProps = reduxState.products.currentProps;
    var Firestore = firebase.firestore();

    var productdataRef = Firestore.collection("products");

    productdataRef = productdataRef.orderBy("created_at", "desc");

    if (currentLastItem) {
      productdataRef = productdataRef.startAfter(currentLastItem);
      console.log(currentProps.searchText);
      if (currentProps.searchText) {
        productdataRef = productdataRef
          .where("name", ">=", currentProps.searchText)
          .where("name", "<=", currentProps.searchText + "\uf8ff");
      }

      if (currentProps.menuItemsOnly) {
        productdataRef = productdataRef.where("menu_item", "==", true);
      } else {
        productdataRef = productdataRef.where("menu_item", "==", false);
      }

      if (userRole == "oic" && userLocation !== "kFM8i7KDX41ex78WPLyO") {
        productdataRef.where("hq_only", "==", false);
      }

      productdataRef = productdataRef.limit(1000);

      productdataRef
        .get()
        .then((documentSnapshots) => {
          var docs = documentSnapshots.docs;
          var lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
          var dataArray = [];
          docs.map((item) => {
            var newProduct = {
              key: item.id,
              id: item.id,
              ...item.data(),
            };

            if (userRole == "admin" || userRole == "manager") {
              dataArray.push(newProduct);
            } else if (newProduct.hq_only || newProduct.menu_item) {
              if (userRole == "oic") {
                if (newProduct.hq_only == false && !newProduct.menu_item) {
                  dataArray.push(newProduct);
                }
              }
              if (userRole == "warehouse") {
                if (newProduct.menu_item == false) {
                  dataArray.push(newProduct);
                }
              }
            } else {
              dataArray.push(newProduct);
            }
          });
          console.log(dataArray);
          if (lastVisible && currentLastItem !== lastVisible) {
            dispatch({
              type: LOAD_MORE_PRODUCT_DATA,
              payload: { dataArray: dataArray, lastVisible: lastVisible },
            });
          } else {
            message.error("No More Orders To Load");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      message.error("Nothing to load more of");
    }
  };
};

export const onChangeIncomingcount = (productID, incoming_count) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products").doc(productID);
    dispatch({
      type: CHANGE_PRODUCT_INCOMING,
      payload: { productID: productID, incoming_count: incoming_count },
    });
    var data = {
      incoming_count: incoming_count,
    };
    return productdataRef.set(data, { merge: true });
  };
};

export const onAcceptIncomingcount = (record) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var reduxState = store.getState();
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;

    var inventoryID = `${userLocation}_${record.id}`;
    var productdataRef = Firestore.collection("products").doc(record.id);
    var inventoryRef = Firestore.collection("inventory").doc(inventoryID);
    var inventoryLogRef = Firestore.collection("inventory")
      .doc(inventoryID)
      .collection("inventory_log")
      .doc();

    var newQuantity = 0;
    if (record.incoming_count) {
      newQuantity = parseFloat(record.incoming_count);
    }
    if (record[`${userLocation}_count`]) {
      newQuantity =
        parseFloat(record.incoming_count) +
        parseFloat(record[`${userLocation}_count`]);
    }
    var inventoryLogForm = {
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      reason: "received incoming",
      created_by: userID,
      created_name: userName,
      quantity: newQuantity,
    };
    if (record[`${userLocation}_restock`]) {
      inventoryLogForm["restock"] = record[`${userLocation}_restock`];
    }

    dispatch({
      type: CHANGE_PRODUCT_INCOMING,
      payload: { productID: record.id, incoming_count: 0 },
    });
    var proddata = {
      incoming_count: 0,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
    };
    proddata[`${userLocation}_count`] = newQuantity;
    var inventoryform = {
      location: userLocation,
      location_name: userLocationName,
      product: record.id,
      product_name: record.name,
      quantity: newQuantity,
      updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      updated_by: userID,
      updated_name: userName,
      reason: "received incoming",
    };

    var productEdit = await productdataRef.set(proddata, { merge: true });

    var InventoryEdit = await inventoryRef.set(inventoryform, { merge: true });

    var makelog = await inventoryLogRef.set(inventoryLogForm);

    return newQuantity;
  };
};

export const setPrice = (data, docID) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products")
      .doc(docID)
      .collection("price_history");
    return productdataRef.doc().set(data, { merge: true });
  };
};

export const getProduct = (id) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products").doc(id);
    var newd = productdataRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          var newdata = doc.data();
          return newdata;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
    return newd;
  };
};

const CHUNK_SIZE = 10;

// simple utility to split an array into chunks
function chunkArray(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

/**
 * Fetch multiple products by ID, returning only the specified fields.
 *
 * @param {string[]} ids           – Array of document IDs (any length)
 * @param {string[]} fields        – Firestore field paths to return (e.g. ["name", "price"])
 * @returns {Promise<object[]>}    – [{ id, ...selectedFields }, …]
 */
export const getProductsBulk = (ids, fields = []) => {
  return async (dispatch) => {
    if (!Array.isArray(ids) || ids.length === 0) {
      return [];
    }

    const firestore = firebase.firestore();
    const idChunks = chunkArray(ids, CHUNK_SIZE);

    // build one query-per-chunk, each selecting only the desired fields
    const queries = idChunks.map((chunk) => {
      let q = firestore
        .collection("products")
        .where(firebase.firestore.FieldPath.documentId(), "in", chunk);

      return q.get();
    });

    // fire them all off in parallel
    const snapshots = await Promise.all(queries);

    // flatten, dedupe, and map to plain objects
    const allDocs = snapshots
      .flatMap((snap) => snap.docs)
      .filter((doc, i, arr) => arr.findIndex((d) => d.id === doc.id) === i);

    const products = allDocs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    return products;
  };
};

export const getProductIngredients = (currentProduct) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products")
      .doc(currentProduct)
      .collection("ingredients");

    return productdataRef.get();
  };
};

export const addProductIngredients = (data, currentProduct) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection("products")
      .doc(currentProduct)
      .collection("ingredients");
    return productdataRef.doc().set(data);
  };
};

export const editProductIngredients = (data, currentProduct, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection("products")
      .doc(currentProduct)
      .collection("ingredients");

    return OrdersRef.doc(id).update(data);
  };
};

export const deleteProductIngredients = (currentProduct, id) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var OrdersRef = Firestore.collection("products")
      .doc(currentProduct)
      .collection("ingredients");

    return OrdersRef.doc(id).delete();
  };
};

export const updateItem = (data, apiurl) => {
  return (dispatch) => {
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection(apiurl);
    return productdataRef.doc().update(data);
  };
};

export const openPreview = (item, previewModalOpen) => {
  return (dispatch) => {
    dispatch({
      type: OPEN_PREVIEW,
      item: item,
      previewModalOpen: previewModalOpen,
    });
  };
};

export const getOptions = (props) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;
    var useremail = reduxState.auth.user.email;
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection(props.apiurl);
    // console.log(props)
    productdataRef = productdataRef.orderBy("created_at", "desc");

    if (props.searchText) {
      productdataRef = productdataRef
        .where("name", ">=", props.searchText)
        .where("name", "<=", props.searchText + "\uf8ff");
    }

    productdataRef = productdataRef.limit(1000);

    return productdataRef.get();
  };
};

const config = {
  bucketName: process.env.REACT_APP_AWS_S3_BUCKETNAME,
  dirName: "products" /* optional */,
  region: "ap-southeast-1",
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
};

const ReactS3Client = new S3(config);
/*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */

export const UploadProductPicture = (file, itemid) => {
  return (dispatch) => {
    // console.log(config);
    const newFileName = `${itemid}.png`;
    return ReactS3Client.uploadFile(file, newFileName);
  };
};

export const toggleDirectShip = (id, toggleState, locationId) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();
    var productRef = Firestore.collection("products");
    var docRef = productRef.doc(id);

    try {
      if (toggleState) {
        // If toggle is true, add the ID to the direct_ship array
        await docRef.update(
          {
            direct_ship: firebase.firestore.FieldValue.arrayUnion(locationId),
          },
          { merge: true }
        );
      } else {
        // If toggle is false, remove the ID from the direct_ship array
        await docRef.update(
          {
            direct_ship: firebase.firestore.FieldValue.arrayRemove(locationId),
          },
          { merge: true }
        );
      }

      console.log("Operation completed");
      message.success("direct ship toggled");
    } catch (error) {
      console.error("Error in Firestore operation:", error);
      message.error("ERROR: direct ship not toggled");
    }
  };
};

export const getMenuItemsWithDuplicateIngredients = () => {
  return async (dispatch) => {
    const Firestore = firebase.firestore();

    // 1) grab all menu‐item products
    const menuSnap = await Firestore.collection("products")
      .where("menu_item", "==", true)
      .get();

    const duplicatesResult = [];

    // 2) for each menu product, check its ingredients
    await Promise.all(
      menuSnap.docs.map(async (prodDoc) => {
        const prodData = prodDoc.data();
        const ingrSnap = await Firestore.collection("products")
          .doc(prodDoc.id)
          .collection("ingredients")
          .get();

        // 3) build a map of counts and a map of names
        const countMap = {};
        const nameMap = {};
        ingrSnap.docs.forEach((doc) => {
          const { product: pid, product_name: pname } = doc.data();
          countMap[pid] = (countMap[pid] || 0) + 1;
          nameMap[pid] = pname;
        });

        // 4) collect only those with count > 1
        const dupList = Object.entries(countMap)
          .filter(([, cnt]) => cnt > 1)
          .map(([pid, cnt]) => ({
            ingredientId: pid,
            ingredientName: nameMap[pid],
            count: cnt,
          }));

        if (dupList.length) {
          duplicatesResult.push({
            productId: prodDoc.id,
            productName: prodData.name,
            duplicateIngredients: dupList,
          });
        }
      })
    );

    console.log("duplicatesResult", duplicatesResult);

    return duplicatesResult;
  };
};
